import { UtensilsCrossed } from "lucide-react";
import { eur } from "../../lib/quotesApi";

export function QuoteMenuBlock({ menu }) {
  if (!menu?.enabled || !(menu.courses || []).length) return null;
  const show = menu.show_alacarte !== false;
  const ala = menu.alacarte_per_person_cents || 0;
  const pp = menu.per_person_cents || 0;
  return (
    <div className="rounded-2xl bg-white border border-[#e8dcc8] shadow-sm overflow-hidden" data-testid="quote-menu">
      <div className="px-5 py-3 border-b border-[#e8dcc8] text-[11px] uppercase tracking-[0.2em] text-[#C48B31] font-bold inline-flex items-center gap-2"><UtensilsCrossed className="h-3.5 w-3.5" /> Il menu</div>
      <div className="px-5 pt-5 pb-2 text-center">
        <h2 className="font-serif text-2xl sm:text-3xl font-bold text-[#4a1c17]" data-testid="quote-menu-title">{menu.title}</h2>
        {menu.note && <p className="text-xs text-[#7c5a4e] mt-1">{menu.note}</p>}
      </div>
      <div className="px-5 pb-5 space-y-5">
        {menu.courses.map((c) => (
          <div key={c.id} data-testid="quote-menu-course">
            <div className="text-center text-[11px] uppercase tracking-[0.25em] text-[#7c5a4e] mb-2">{c.name}{c.choice && <span className="normal-case tracking-normal"> · a scelta tra</span>}</div>
            <ul className="space-y-2">
              {(c.dishes || []).map((d) => (
                <li key={d.id} className="flex items-start gap-3" data-testid="quote-menu-dish">
                  {d.image && <img src={d.image} alt="" className="h-12 w-12 rounded-lg object-cover shrink-0" loading="lazy" />}
                  <div className="flex-1 min-w-0"><div className="font-serif text-lg leading-snug">{d.name}</div>{d.desc && <div className="text-xs text-[#7c5a4e] mt-0.5">{d.desc}</div>}</div>
                  {show && <div className="text-sm tabular-nums text-[#7c5a4e] whitespace-nowrap" title="Prezzo alla carta">{eur(d.alacarte_cents)}</div>}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      {pp > 0 && (
        <div className="px-5 py-4 bg-[#faf3ee] text-sm space-y-1" data-testid="quote-menu-summary">
          {show && ala > 0 && <div className="flex justify-between text-[#7c5a4e]"><span>Valore alla carta a persona</span><span className="line-through tabular-nums">{eur(ala)}</span></div>}
          <div className="flex justify-between items-baseline"><span className="font-bold">Prezzo del menu a persona</span><span className="font-serif text-xl font-bold text-[#4a1c17] tabular-nums" data-testid="quote-menu-pp">{eur(pp)}</span></div>
          {show && ala > pp && <div className="flex justify-between text-emerald-700 font-semibold"><span>Il vostro risparmio a persona</span><span className="tabular-nums">{eur(ala - pp)}</span></div>}
        </div>
      )}
    </div>
  );
}
